// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
console.log('🚀 application.js cargado');

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "controllers"
import "bootstrap"
import "../src/add-eu-banner"

require("trix")
require("@rails/actiontext")

// ——— Pixel tracking para WhatsApp ———
function trackWhatsappClick() {
  if (window.fbq) {
    fbq('trackCustom', 'WhatsappClick');
  }
}

document.addEventListener('turbolinks:load', () => {
  const btn = document.getElementById('whatsapp-link');
  if (btn) {
    btn.addEventListener('click', trackWhatsappClick);
  }
});
document.addEventListener('turbolinks:load', () => {
  const btn = document.getElementById('whatsapp-link');
  console.log('Botón WhatsApp encontrado:', !!btn);
  if (btn) {
    btn.addEventListener('click', () => {
      console.log('🔔 trackWhatsappClick disparado');
      if (window.fbq) fbq('trackCustom', 'WhatsappClick');
    });
  }
});
